import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor } from '../../common/services/httpInterceptor.service';
import { ConfigService } from '../../common/services/config.service';
import { SessionHandlerService } from '../../common/services/sessionHandler.service';
import { CommonConstants } from '../../common/utilities/commonConstants';
import { Subject } from 'rxjs';
import { SharedService } from '../../common/services/sharedService';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PlanProductListingService {
  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();
  public bflJourney: boolean = environment['bflenvironment'];
  private plansList: any[] = [];
  constructor(
    private _httpInterceptor: HttpInterceptor,
    private _sessionHandler: SessionHandlerService,
    public _sharedService: SharedService,
    private sessionHandlerService: SessionHandlerService
  ) { }

  public PostPreviousPolicyCallService(data) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.postCallPreviousPolicy;
    url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
    return this._httpInterceptor.Post(url, data);
  }
  public GetPreviousPolicyDetails() {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getPreviousPolicyDetails;
    url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
    url = url.replace('{prevPolicyDetId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.PrevPolicyDetId) === '' ? 0
      : this._sessionHandler.GetSession(CommonConstants.CookieKeys.PrevPolicyDetId));
    return this._httpInterceptor.Get(url);
  }
  public GetQuoteIds(quoteId: string): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getPollingQuotes;
    url = url.replace('{quoteId}', quoteId);
    return this._httpInterceptor.GetPollingRetry(url, true);
  }
  public GetPlanSummary(quoteId) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getPlanSummary;
    url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
    url = url.replace('{quoteId}', quoteId);
    return this._httpInterceptor.Get(url);
  }
  public GetRiderService(productCategoryCode) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getRiders;
    url = url.replace('{productCategoryCode}', productCategoryCode);
    return this._httpInterceptor.Get(url);
  }
  public Refinment(data: any) {
    const url = (ConfigService.getInstance().getConfigObject().APIURL.refinements);
    return this._httpInterceptor.Post(url, data);
  }
  public DownloadBrochure(variantCode: string): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.downloadPlanBrochure;
    url = url.replace('{variantcode}', variantCode);
    return this._httpInterceptor.Get(url, true);
  }
  /*** Get the AEM data */
  public getAemDetails(): Observable<any> {
    let bflJourney = this._sharedService.isBFLJourney();
    if (bflJourney) {
      let url = ConfigService.getInstance().getConfigObject().AEMURL.PlanListAembfl;
      return this._httpInterceptor.GetAem(url);
    } else {
      let url = ConfigService.getInstance().getConfigObject().AEMURL.PlanListAem;
      return this._httpInterceptor.GetAem(url);
    }
  }
  public getNewCarAemDetails(): Observable<any> {
    let bflJourney = this._sharedService.isBFLJourney();
    if (bflJourney) {
      let url = ConfigService.getInstance().getConfigObject().AEMURL.NewCarInsAemBfl;
      return this._httpInterceptor.GetAem(url);
    }
  }
  public searchNetworkGarages(productKey, garageName, cityKey) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.networkGarage;
    url = url.replace('{0}', cityKey);
    url = url.replace('{1}', productKey);
    url = url.replace('{2}', garageName);
    return this._httpInterceptor.Get(url);
  }
  public getNetworkGarageCount(cityKey, productKey) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.networkGarage;
    url = url.replace('{0}', cityKey);
    url = url.replace('{1}', productKey);
    url = url.replace('{2}', '');
    return this._httpInterceptor.Get(url);
  }
  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }
  // public getAemDetailsLandingpage(): Observable<any> {
  //   let bflJourney = this._sharedService.isBFLJourney();
  //   if (bflJourney){
  //     let url = ConfigService.getInstance().getConfigObject().AEMURL.LandingpageAembfl;
  //     return this._httpInterceptor.GetAem(url);
  //   } else{
  //     let url = ConfigService.getInstance().getConfigObject().AEMURL.LandingpageAem;
  //     return this._httpInterceptor.GetAem(url);
  //   }
  // }
  public Inquiries(data: any): Observable<ActivitiModel.MTResponse<any>> {
    return this._httpInterceptor.Post(
      ConfigService.getInstance().getConfigObject().APIURL.inquiries, data);
  }
  async displayPlansInAccordion(plans: any[], vehicleAge: number) {
    return new Promise(async (resolve, reject) => {
      const vehicleAgeCheck = await this.checkVehicleAge(plans, vehicleAge);
      resolve(this.plansList);
    });
  }

  async checkVehicleAge(plans: any[], vehicleAge: number) {
    const vehicleType: string = this.sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
    let vehicleAgeToBeComparedWith: number;
    if (vehicleType === 'FWGI') {
      vehicleAgeToBeComparedWith = 2.75;
    } else if (vehicleType === 'TWGI') {
      vehicleAgeToBeComparedWith = 4.75;
    }

    if (vehicleAge <= vehicleAgeToBeComparedWith) {
      // Filter and display OD plans
      await this.filterPlans(plans, ['RENEWAL','OD']);
    } else if (vehicleAge > vehicleAgeToBeComparedWith) {
      // Filter and display CI and TP plans
      await this.filterPlans(plans, ['LCP','RENEWAL','CP', 'TP']);
    }

    return Promise.resolve();
  }
  async filterPlans(plans: any[], planTypes: string[], isSinglePlanTypeSelected: boolean = false) {
    let val: any = true;
    this.plansList = [];
    // console.log('plans', plans);
    // Check if more than one plan type is selected
    const multiplePlanTypesSelected = planTypes.length > 1;


    planTypes?.forEach((planType: string, i: number) => {
      let filteredPlans = [];
      const renewalPlans = []

      plans?.forEach(plan => {
        plan.premiumPlans.forEach((premiumPlan) => {
          premiumPlan.dummyCard = plan.dummyCard || false;
          premiumPlan.principalRedirectionUrl = plan.principalRedirectionUrl;
          // premiumPlan.autoleaseRenewalFlag = plan.principalCode === 'ICICI' ? true : plan.autoleaseRenewalFlag || false;
          premiumPlan.autoleaseRenewalFlag = plan?.autoleaseRenewalFlag || false; // Remove HDFCERGO condition once we recieve autoleaseRenewalFlag from api
          premiumPlan.registrationNumber = plan?.vehicleDetails?.registrationNumber;
          premiumPlan.policyExpiryDate = plan?.previousPolicyDetails?.policyExpiryDate;
        });
        const premiumPlans = plan.premiumPlans;
        
        const filteredPlansByPlanType = premiumPlans.filter((plan) =>  {
          if (plan?.autoleaseRenewalFlag && CommonConstants.renewalPlans.some(renewalPlan => plan?.principalCode?.includes(renewalPlan))) {
            renewalPlans.push(plan);
          }
          return plan.planTypeCode === planType && !plan?.autoleaseRenewalFlag;
        });
        filteredPlans = filteredPlans.concat(filteredPlansByPlanType);
      });

      // Set displayAccordion based on the condition
      const displayAccordion = multiplePlanTypesSelected ? val : false;

      this.plansList.push({
        planType: planType,
        planTypeName: CommonConstants.PlanTypes[planType],
        plans: planType === 'RENEWAL' ? renewalPlans : filteredPlans,
        displayAccordion: !isSinglePlanTypeSelected,
        openAccordion: true
      });
      console.log("this.plansList", this.plansList)
    });
    return Promise.resolve(this.plansList);
  }

  public validatePolicyExpiryDate(policyExpiryDate: string): boolean {
    const policyDate = new Date(policyExpiryDate);
    const currentMaxDate = new Date();
    currentMaxDate.setDate(currentMaxDate.getDate() + 59);
    if (Number(policyDate > currentMaxDate)) {
      return true;
    } else {
      return false;
    }
  }

  public checkPPED(policyExpiryDate: string): boolean {
    const policyDate = new Date(policyExpiryDate);
    const todayDate = new Date();
    if (Number(policyDate.getFullYear() >= 2000 && policyDate.setHours(0,0,0,0) < todayDate.setHours(0,0,0,0))) {
      return true;
    }else {
      return false;
    }
  }
}

